module.exports = __webpack_public_path__ + "img/banner_es.ff1702af.jpg";